import React from "react";
import NavButton from "../../components/ul/NavButton";

// Google ad formats are all managed on the single Google Ads page now.
const GOOGLE_STATES = ["nativeads", "fsads", "bannerads", "openads", "rewardads"];

const AdsNavbar = ({ selectState }) => {
  const isGoogle = GOOGLE_STATES.includes(selectState);

  const topTabs = [
    {
      to: "/manage/ads/nativeAds/add",
      name: "Google Ads",
      active: isGoogle,
    },
    {
      to: "/manage/ads/inhouseads/add",
      name: "Inhouse Ads",
      active: selectState === "inhouseads",
    },
  ];

  return (
    <nav className="text-main-font w-full p-3 sm:p-4">
      <div className="ui-card px-3 py-2">
        <ul className="flex flex-1 sm:flex-none gap-2">
          {topTabs.map((tab) => (
            <li key={tab.name} className="flex-1 sm:flex-none">
              <NavButton
                to={tab.to}
                btnName={tab.name}
                selectState={tab.active}
                className="w-full sm:w-auto"
              />
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default AdsNavbar;
